import Reveal from "@/components/Reveal";

const STEPS = [
  ["01", "Share your files", "Send PDFs or docs on WhatsApp, or drop the details in our enquiry form."],
  ["02", "Approve the quote", "We confirm paper, binding and price in minutes. No surprises later."],
  ["03", "We print & bind", "Your job runs on our digital floor — colour-matched and edge-trimmed."],
  ["04", "Pickup or delivery", "Collect at the store, or get it couriered anywhere in Mumbai."],
];

export default function Process() {
  return (
    <section id="process" className="py-20 lg:py-28" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="mb-12">
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyanbrand">
            / How it works
          </span>
          <h2 className="mt-4 font-display font-semibold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-paper">
            Four steps. One deadline.
          </h2>
        </Reveal>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block absolute top-8 left-0 right-0 h-px bg-edge" aria-hidden="true" />
          {STEPS.map(([num, title, desc], i) => (
            <Reveal key={num} delay={i} className="relative">
              <div className="h-full border border-edge bg-surface rounded-sm p-7 hover:border-cyanbrand/40 transition-colors duration-300">
                <div className="relative inline-flex">
                  <span className="font-mono text-4xl font-semibold text-outline" style={{ WebkitTextStroke: "1px #00E5FF", color: "transparent" }}>
                    {num}
                  </span>
                  <span className="absolute -top-2 -left-3 w-4 h-4 rounded-full bg-ink border border-cyanbrand/60" aria-hidden="true" />
                </div>
                <h3 className="mt-6 font-display font-semibold text-xl text-paper tracking-tight">{title}</h3>
                <p className="mt-3 text-sm text-mist leading-relaxed">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
